import { createTheme } from "@mui/material";
import palette from "./palette";

const theme = createTheme({
    palette,
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    "& .MuiDataGrid-cell": {
                        "&:focus-within": {
                            outline: "unset",
                        },
                    },
                    "& .MuiDataGrid-columnHeader": {
                        "&:focus": {
                            outline: "unset",
                        },
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: "#32475b",
                    color: "white",
                    opacity: 1,
                },
            },
        },
    },
});

export default theme;
